import script from "./ListingSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListingSwitch.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__